"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.template = (translate) => `
  <e-dialog headline="${translate('dialogHeadline')}">
    <center>
      <e-spinner data-size="medium"></e-spinner>
    </center>
    <div class="e-dialog__footer">
      <div class="e-buttongroup">
        <button class="e-btn cancel-btn" type="reset">
          ${translate('dialogCancelButtonLabel')}
        </button>
        <button class="e-btn e-btn-primary ok-btn" type="submit">
          ${translate('dialogOkButtonLabel')}
        </button>
      </div>
    </div>
  </e-dialog>
`;
//# sourceMappingURL=dialog-handler.template.js.map